import {PlaygroundChat} from './PlaygroundChat'
import {PlaygroundInputs} from './PlaygroundInputs'
import type {ShowModelPayload} from '../../../../types'
import {useEffect} from 'react'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {usePlaygroundManager, usePlaygroundState, type ModelState} from '../../../utils/playground-manager'

export function Playground({model, position}: {model: ModelState; position: number}) {
  const {miniplaygroundIcebreaker} = useRoutePayload<ShowModelPayload>()
  const manager = usePlaygroundManager()
  const playgroundState = usePlaygroundState()
  const onComparisonMode = playgroundState.models.length > 1
  useEffect(() => {
    manager.checkForIcebreaker(miniplaygroundIcebreaker, playgroundState, model)
  }, [manager, miniplaygroundIcebreaker, playgroundState, model])

  return (
    <div
      className={`flex-1 d-flex flex-column flex-md-row border overflow-hidden ${
        onComparisonMode ? 'rounded-bottom-2' : 'rounded-2'
      }`}
    >
      <PlaygroundChat model={model} position={position} />
      <PlaygroundInputs model={model} position={position} />
    </div>
  )
}

try{ Playground.displayName ||= 'Playground' } catch {}